<template>
	<div class="childDiv2" id="page8" ref="mainEl" page="1">
		<img src="images/1x_images/section2/page1/serum-bg.png" srcset="images/2x_images/section2/page1/serum-bg.png 2x" class="img-bg" />

		<div class="childWrapper">
			<img alt="" src="images/1x_images/section2/page1/serum-page1-title.png" srcset="images/2x_images/section2/page1/serum-page1-title.png 2x" class="button absolute top-[197px] center" />
			<img alt="" @click="showVideo()" src="images/1x_images/section2/page1/btn-youthful.png" srcset="images/2x_images/section2/page1/btn-youthful.png 2x" class="button absolute top-[380px] center" />
		</div>

		<!-- video modal -->
		<div class="modal absolute top-0" ref="modalEl">
			<div class="childWrapper">
				<img alt="" class="button relative top-[180px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close()" />
				<div class="absolute top-[300px] w-full">
					<VideoComp :url="'videos/Video-Serum.mp4'" :poster="'videos/Poster-skin-Serum.png'" ref="videoEl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import VideoComp from "../../components/Videos.vue";
import gsap from "gsap";

export default {
	name: "page-1",
	components: { VideoComp },
	data() {
		return {};
	},
	methods: {
		start() {},
		stop() {
			this.reset();
		},
		showVideo() {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page2-menu", { autoAlpha: 0 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 1 });
			this.$refs.videoEl.start();
		},
		close() {
			this.reset();
		},
		reset() {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page2-menu", { autoAlpha: 1 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
			this.$refs.videoEl.reset();
		},
	},
	mounted() {},
};
</script>

<style scoped></style>
